import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";

function GridDetails(data: any) {
    const columns = data.columnNames.map((item: any) => <Column field={item.field} title={item.title} />)
    return (<Grid data={data.gridData} style={{ maxHeight: 320, minWidth: 500 }} scrollable='none'>
        {columns}
    </Grid>);
}

export default GridDetails;